var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-content',{staticClass:"beta md-accent"},[_vm._v(" Bêta 0.1.0 ")])}
var staticRenderFns = []

export { render, staticRenderFns }